import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './DiscussionContent.scss';
import { truncateWithEllipsis } from '../../../utilities/ui_utilities';

const DiscussionContent = ({
    title,
    description,
    characterLimit,
    showMoreButton,
    handleLinkClickMetricEmit,
}) => {
    const [expandContent, setExpandContent] = useState(!showMoreButton);
    const truncatedDescription = truncateWithEllipsis(
        `${description || ''}`,
        characterLimit,
        false
    );

    const handleExpandClick = () => {
        handleLinkClickMetricEmit('more-content-click');
        setExpandContent(true);
    };

    return (
        <div className="component-UnifiedPostCard-DiscussionContent">
            {title?.length > 0 && (
                <div className="component-UnifiedPostCard-DiscussionContent__title">
                    {title}
                </div>
            )}
            {description?.length > 0 && (
                <div className="component-UnifiedPostCard-DiscussionContent__body">
                    {!showMoreButton || expandContent
                        ? description
                        : truncatedDescription}
                    {showMoreButton && !expandContent ? (
                        <button
                            type="button"
                            className="component-UnifiedPostCard-DiscussionContent__body__more"
                            onClick={handleExpandClick}
                        >
                            ...More
                        </button>
                    ) : null}
                </div>
            )}
        </div>
    );
};

DiscussionContent.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    showMoreButton: PropTypes.bool,
    characterLimit: PropTypes.number,
    handleLinkClickMetricEmit: PropTypes.func,
};

DiscussionContent.defaultProps = {
    title: '',
    description: '',
    showMoreButton: false,
    characterLimit: 420,
    handleLinkClickMetricEmit: () => null,
};

DiscussionContent.displayName = 'DiscussionContent';

export default DiscussionContent;
